export default {
    namespaced: true,
    state: {
        access_page_word_ids: {},
        access_industry_word_ids: {},
        access_page_group_word_ids: {},
        access_campaign_word_ids: {},
        company_visit_list_word_ids: {},
        person_visit_list_word_ids: {}
    },
    mutations: {
        // access_page用のワードIDをセット
        setAccessPageWordIds(state, access_page_word_ids) {
            state.access_page_word_ids = access_page_word_ids;
        },
        // access_industry用のワードIDをセット
        setAccessIndustryWordIds(state, access_industry_word_ids) {
            state.access_industry_word_ids = access_industry_word_ids;
        },
        // access_page_group用のワードIDをセット
        setAccessPageGroupWordIds(state, access_page_group_word_ids) {
            state.access_page_group_word_ids = access_page_group_word_ids;
        },
        // access_campaign用のワードIDをセット
        setAccessCampaignWordIds(state, access_campaign_word_ids) {
            state.access_campaign_word_ids = access_campaign_word_ids;
        },
        // company_visit_list用のワードIDをセット
        setCompanyVisitListWordIds(state, company_visit_list_word_ids) {
            state.company_visit_list_word_ids = company_visit_list_word_ids;
        },
        // person_visit_list用のワードIDをセット
        setPersonVisitListWordIds(state, person_visit_list_word_ids) {
            state.person_visit_list_word_ids = person_visit_list_word_ids;
        }
    },
    actions: {},
    getters: {
        // access_page用のワードIDを取得
        getAccessPageWordIds(state) {
            return state.access_page_word_ids;
        },
        // access_industry用のワードIDを取得
        getAccessIndustryWordIds(state) {
            return state.access_industry_word_ids;
        },
        // access_page_group用のワードIDを取得
        getAccessPageGroupWordIds(state) {
            return state.access_page_group_word_ids;
        },
        // access_campaign用のワードIDを取得
        getAccessCampaignWordIds(state) {
            return state.access_campaign_word_ids;
        },
        // company_visit_list用のワードIDを取得
        getCompanyVisitListWordIds(state) {
            return state.company_visit_list_word_ids;
        },
        // person_visit_list用のワードIDを取得
        getPersonVisitListWordIds(state) {
            return state.person_visit_list_word_ids;
        }
    }
};
